"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompetitorsIcon = createIcon({
  displayName: "CompetitorsIcon",
  viewBox: "0 0 45 32",
  path: (
    <>
      <path
        d="M0,32v-8c0-1.13.4-2.08,1.2-2.85.8-.77,1.76-1.15,2.89-1.15h6.7c.68,0,1.33.17,1.94.5.61.33,1.11.78,1.48,1.35.99,1.3,2.21,2.32,3.66,3.05,1.45.73,2.99,1.1,4.63,1.1s3.23-.37,4.68-1.1c1.45-.73,2.65-1.75,3.61-3.05.44-.57.96-1.02,1.56-1.35.6-.33,1.22-.5,1.87-.5h6.7c1.16,0,2.13.38,2.91,1.15.78.77,1.18,1.72,1.18,2.85v8h-14.32v-4.55c-1.19.83-2.48,1.47-3.86,1.9-1.38.43-2.82.65-4.32.65s-2.9-.23-4.3-.67c-1.4-.45-2.69-1.09-3.89-1.93v4.6H0ZM22.5,24c-1.3,0-2.52-.29-3.68-.88-1.16-.58-2.13-1.39-2.91-2.42-.58-.83-1.3-1.49-2.17-1.98-.87-.48-1.82-.73-2.84-.73.75-1.23,2.34-2.21,4.76-2.93,2.42-.72,4.7-1.07,6.85-1.07s4.43.36,6.85,1.07c2.42.72,4.01,1.69,4.76,2.93-.99,0-1.93.24-2.81.73-.89.48-1.62,1.14-2.2,1.98-.75,1.07-1.7,1.88-2.86,2.45-1.16.57-2.4.85-3.73.85ZM6.14,18c-1.7,0-3.15-.58-4.35-1.75-1.19-1.17-1.79-2.58-1.79-4.25s.6-3.12,1.79-4.28c1.19-1.15,2.64-1.72,4.35-1.72s3.2.57,4.37,1.72c1.18,1.15,1.76,2.58,1.76,4.28s-.59,3.08-1.76,4.25c-1.18,1.17-2.63,1.75-4.37,1.75ZM38.86,18c-1.7,0-3.15-.58-4.35-1.75-1.19-1.17-1.79-2.58-1.79-4.25s.6-3.12,1.79-4.28c1.19-1.15,2.64-1.72,4.35-1.72s3.2.57,4.37,1.72c1.18,1.15,1.76,2.58,1.76,4.28s-.59,3.08-1.76,4.25c-1.18,1.17-2.63,1.75-4.37,1.75ZM22.5,12c-1.7,0-3.15-.58-4.35-1.75-1.19-1.17-1.79-2.58-1.79-4.25s.6-3.12,1.79-4.27c1.19-1.15,2.64-1.73,4.35-1.73s3.2.57,4.37,1.73c1.18,1.15,1.76,2.58,1.76,4.27s-.59,3.08-1.76,4.25c-1.18,1.17-2.63,1.75-4.37,1.75Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default CompetitorsIcon;
